import {SORT_BY_NUMBER, SORT_BY_ODD} from '../constants/sortingTypes';

//store.getState() must be bound to this helper
export function sortRacers(a, b) {
    if (a && b) {
        switch (this.selectedRaceCardSortField) {
            case SORT_BY_ODD:
                return a.oddsFirst - b.oddsFirst;
            case SORT_BY_NUMBER:
                return a.num - b.num;
            default:
        }
    }
}

//store.getState() must be bound to this helper
export function sortMarkets(a, b) {
    if (a && b) {
        switch (this.selectedRaceCardSortField) {
            case SORT_BY_ODD:
                return a.odds - b.odds;
            case SORT_BY_NUMBER:
                return a.num - b.num;
            default:
        }
    }
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/helpers/sortingHelper.js